module.exports = __webpack_public_path__ + "img/icon.ccd44f21.png";